import * as classnames from 'classnames'
import * as React from 'react'

import { Plan } from '../../../../commons/Plan'
import * as styles from './PaidStatusLabel.css'

interface PaidStatusLabelProps {
  plan: Plan
}

const PaidStatusLabel: React.FunctionComponent<PaidStatusLabelProps> = ({ plan }) => {
  const paid = plan !== Plan.FREE
  return (
    <div className={classnames(styles.container, paid ? styles.paid : styles.guest)}>
      {paid ? <span className={styles.check} /> : null}
      <p className={styles.text}>{paid ? '購入済' : '未購入'}</p>
    </div>
  )
}

export default PaidStatusLabel
